import { CookieAttributes } from "js-cookie";
import { StripePaymentElementOptions } from "@stripe/stripe-js";
import { getRootDomain, isHttps } from "../../utils/browserUtils";

const domain = getRootDomain(window.location.host);

export const cookieAttributes: CookieAttributes = isHttps()
  ? {
      domain: domain,
      secure: true,
      sameSite: "None",
    }
  : {
      domain: domain,
    };

export const paymentElementOptions: StripePaymentElementOptions = {
  wallets: {
    applePay: "never",
    googlePay: "never",
  },
};

export const validEmailRegex = /\S+@\S+\.\S+/;
